(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.srInit) return;
      root.dataset.srInit = '1';

      initBreakdown(root);

      var track = root.querySelector('[data-sr-track]');
      var prev = root.querySelector('[data-sr-prev]');
      var next = root.querySelector('[data-sr-next]');
      if (!track || !prev || !next) return;

      function step() {
        var card = track.querySelector('.sr-card');
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      }

      function update() {
        // 2px slack: browsers round scrollLeft off at fractional card widths
        var scrollable = track.scrollWidth - track.clientWidth > 2;
        prev.hidden = !scrollable;
        next.hidden = !scrollable;
        if (!scrollable) return;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    // Distribution + subscores: click/tap toggle. Hover keeps working through
    // CSS on devices that support it; this makes the panel reachable on touch
    // too (iOS does not focus a span on tap).
    function initBreakdown(root) {
      var btn = root.querySelector('[data-sr-breakdown]');
      var wrap = root.querySelector('[data-sr-breakdown-wrap]');
      if (!btn || !wrap) return;

      function setOpen(open) {
        wrap.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      btn.addEventListener('click', function (event) {
        event.stopPropagation();
        setOpen(!wrap.classList.contains('is-open'));
      });

      document.addEventListener('click', function (event) {
        if (!wrap.contains(event.target)) setOpen(false);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && wrap.classList.contains('is-open')) {
          setOpen(false);
          btn.focus();
        }
      });
    }

    function initAll() {
      document.querySelectorAll('[data-shop-reviews]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Theme editor: section re-rendered after a settings change
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
